import React, { useState } from 'react';



const Head = () => {
 

    return (
        <div className='head'>
            <div className='head2'>
                <a href='Tel:9140474598'>+91 9140474598</a>
            </div>
            
            <div className='head2'>
                <p>parulhospitaljkp@gmail.com</p>
            </div>
            <div className='head3'>
                <p>Sec-F Jankipuram Near Engineering College Chauraha Lucknow 226021 </p>
            </div>
           
        </div>
    );
};

export default Head;
